import { compose } from 'recompose';
import Filters from './filters';

const enhancer = compose(
);
export default enhancer(Filters);
